import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bootstrap-alert',
  templateUrl: './bootstrap-alert.component.html',
  styleUrls: ['./bootstrap-alert.component.scss']
})
export class BootstrapAlertComponent implements OnInit {
  message: string;
  show: boolean;
  type: string = "";
  class: string = `alert alert-${
    this.type
  } col-md-10 col-sm-10 col-xs-10 col-md-offset-1 col-sm-offset-1 col-xs-offset-1 animated fadeInDown`;

  constructor() {}

  ngOnInit() {}

  public showAlert(message: string, type: EAlertType) {
    this.message = message;
    switch (type) {
      case EAlertType.Danger:
        this.type = 'danger';
        break;
      case EAlertType.Info:
        this.type = 'info';
        break;
      case EAlertType.Success:
        this.type = 'success';
        break;
        case EAlertType.Warning:
        this.type = 'warning';
        break;
    }

    this.show = true;
  }

  public hideAlert() {
    this.show = false;
  }
}

export enum EAlertType {
  Danger,
  Success,
  Info,
  Warning
}
